'use client'

import { useContext } from 'react'
import { UncrawlableLink } from 'components/UncrawlableLink'
import { LayoutContext } from 'providers/LayoutProvider'
import { mainProductConfig } from 'constants/mainProductConfig'
import { _get } from 'utils/shared'
import classNames from 'classnames'

export function UncrawlableLinkV2({ node, variantClass, classNameOverride }) {
  const { linkHref, linkText, target } = _get(node, 'data.target.fields', {})
  const { state: { siteEnv } = {} } = useContext(LayoutContext)

  return (
    <UncrawlableLink
      href={linkHref}
      target={target}
      track={{
        list_name: 'Uncrawlable Link',
        click_text: `${
          mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
        } | ${linkHref}`,
        click_type: 'Uncrawlable Link Click',
        track_event: 'ui_click',
        href: linkHref,
      }}
      className={classNames(variantClass, classNameOverride)}
      data-testid={`Uncrawlable-Link-${linkText}`}
      component="button"
    >
      {linkText}
    </UncrawlableLink>
  )
}
